﻿import { getAllPerguntaComResposta, Pergunta } from '@app/api/minuta/Pergunta';
import { Resposta } from '@app/api/minuta/Resposta';
import {
  Button,
  FormatText,
  FormContext,
  FormInput,
  FormSubmitButton,
  Icon,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Collapse, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import TabelaRespostasItemClausula from './TabelaRespostasItemClausula';

interface PropsModalSelectResposta {
  limparResposta: boolean;
  disable: boolean;
  onGetRespostasSelecionadas: (respostas: Resposta[]) => void;
}

const ModalSelectResposta = ({ limparResposta, disable, onGetRespostasSelecionadas }: PropsModalSelectResposta) => {
  const { Panel } = Collapse;

  const { formProps } = useContext(FormContext);
  const [perguntaResult, setPerguntaResult] = useState<Pergunta[]>([]);
  const [perguntaResultBase, setPerguntaResultBase] = useState<Pergunta[]>([]);
  const [respostas, setRespostas] = useState<Resposta[]>([]);
  const [exibirModal, setExibirModal] = useState(false);

  const undoFiltering = () => {
    setPerguntaResult(perguntaResultBase);
  };

  const handleSubmit = (values: any) => {
    if (values.termo == '') {
      undoFiltering();
    } else {
      const filteredPerguntaResult = perguntaResultBase.filter((per: Pergunta) =>
        per.pergunta.toUpperCase().includes(values.termo.toUpperCase()),
      );
      setPerguntaResult(filteredPerguntaResult);
    }
  };

  useEffect(() => {
    setRespostas([]);
    setPerguntaResult({} as Pergunta[]);
    setPerguntaResultBase({} as Pergunta[]);

    if (exibirModal) {
      getAllPerguntaComResposta().then(data => {
        if (data) {
          setPerguntaResultBase(data);
          setPerguntaResult(data);
        }
      });
    }
  }, [exibirModal, limparResposta]);

  const onCloseModal = () => {
    setRespostas([]);
    undoFiltering();
    setExibirModal(false);
  };

  const onSelectResposta = () => {
    if (formProps) {
      formProps.setFieldValue('respostas', respostas);
      onGetRespostasSelecionadas(respostas);
      onCloseModal();
    }
  };

  return (
    <>
      <FormInput
        label="Respostas"
        name="respostas"
        span={4}
        value={
          formProps && formProps.values.respostas && formProps.values.respostas.length > 0
            ? formProps.values.respostas.map(r => r.descricao).join(', ')
            : ''
        }
        onClick={() => {
          onCloseModal();
          setExibirModal(true);
        }}
        id="respostas"
        disabled={disable}
      />
      {exibirModal && !disable && (
        <Modal
          title="Pesquisa de resposta"
          width="800px"
          visible={exibirModal}
          onCancel={onCloseModal}
          footer={[
            <Button key="submitCancelar" type="link" onClick={onCloseModal}>
              Fechar
            </Button>,
            respostas.length > 0 && (
              <Button key="submitEnviar" type="primary" onClick={onSelectResposta}>
                Enviar
              </Button>
            ),
          ]}>
          <MasterDetailForm
            initialValues={{}}
            key="formTemplate"
            onSubmit={handleSubmit}
            actions={[
              <Button key="close" type="link" onClick={onCloseModal}>
                Fechar
              </Button>,
              <FormSubmitButton key="search" noIcon type="primary">
                <FormatText id="ui.commons.search" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row style={{ margin: '0px' }}>
                <FormInput name="termo" label="Termo" defaultValue={''} id={'perguntaFilter'} />
              </Row>
            </Widget>
          </MasterDetailForm>

          <>
            {perguntaResult && perguntaResult.length > 0 ? (
              <>
                {perguntaResult.map(pergunta => {
                  return (
                    <Collapse key={`${pergunta.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                      <Panel key={`${pergunta.id}`} header={`${pergunta.pergunta}`}>
                        <TabelaRespostasItemClausula
                          perguntaResult={pergunta}
                          onSelectResult={res => setRespostas(res)}
                          respostasChecked={respostas}
                          ocultaEdicao
                        />
                      </Panel>
                    </Collapse>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </>
        </Modal>
      )}
    </>
  );
};

export default ModalSelectResposta;
